import { Img } from 'components/basic/Img'
import { Button } from 'components/Phantom/Button'
import { Icon } from 'components/Phantom/Icon'
import { Type } from 'components/Type'
import { FC } from 'react'
import { useStore } from 'stores/StoreProvider'
import styles from './SleepElixirVanityAd.module.scss'
import { SleepElixirVanityAdProps } from './SleepElixirVanityAd.types'

export const SleepElixirVanityAdConnected = () => {
	const sleepElixirVanityAd = useStore((state) => state.settings.settings.sleepElixirVanityAd)
	if (!sleepElixirVanityAd) {
		return null
	}

	return <SleepElixirVanityAd {...sleepElixirVanityAd} />
}

export const SleepElixirVanityAd: FC<SleepElixirVanityAdProps> = (props) => {
	const {
		eyebrow = 'Other favorites from Tucker',
		heading = 'Discover calm before bedtime',
		description = 'Sleep Elixir is the perfect companion to the Pod, working from within to help you fall asleep faster while the Pod optimizes your external sleep environment.',
		benefits = [
			{ icon: 'MeditationLight', text: 'Calms your mind' },
			{ icon: 'RefreshLight', text: 'Non-habit forming' },
			{ icon: 'MoonLight', text: 'Improves sleep cycles' },
		],
		cta = { text: 'Explore Sleep Elixir', href: '/product/sleep-elixir' },
	} = props

	return (
		<section className={styles.container}>
			<div className={styles.wrapper}>
				<div className={styles.image_container}>
					<Img
						src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/sleep_elixir_vanity_ad.jpg"
						alt="Sleep Elixir"
						className={styles.image}
						objectFit="cover"
					/>
				</div>
				<div className={styles.content}>
					<header>
						<Type.Eyebrow>{eyebrow}</Type.Eyebrow>
						<Type.Headline3>{heading}</Type.Headline3>
						<Type.Body1 className={styles.description}>{description}</Type.Body1>
					</header>
					<ul className={styles.benefits}>
						{benefits.map((benefit) => (
							<li key={benefit.text}>
								<Icon
									name={benefit.icon}
									color="black"
								/>
								<Type.Body2>{benefit.text}</Type.Body2>
							</li>
						))}
					</ul>
					<Button.Dark
						id="sleep-elixir-vanity-ad-cta"
						href={cta.href}
					>
						{cta.text}
					</Button.Dark>
				</div>
			</div>
		</section>
	)
}
